import React from 'react';
import PropTypes from 'prop-types';

import DataModel from '../../../models/DataModel';
import MultiFileUploader from '../../MultiFileUploader';

import './FileUploadModal.scss';

export default class FileUploadModal extends React.Component {

  constructor(props) {
    FileUploadModal.propTypes = {
      /** Called when the modal is closed */
      onClose: PropTypes.func,
      /** remaining props are the same as <MultiFileUploader> */
    };
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { onClose } = this.props;
    DataModel.hideGlobalModal();
    if(onClose) {
      onClose();
    }
  }

  render() {
    return (
      <div className="upload-modal"> 
        <MultiFileUploader 
          hasCloseButton={true}
          modal={true}
          handleClose={this.handleClose}
          {...this.props}
        />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/modals/FileUploadModal/index.js